import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { isAdmin } from './services/auth';
import Home from './pages/Home';
import Social from './pages/Social';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import HeroEditor from './pages/admin/HeroEditor';
import AboutEditor from './pages/admin/AboutEditor';
import EventsEditor from './pages/admin/EventsEditor';
import ResourcesEditor from './pages/admin/ResourcesEditor';
import LeadsPage from './pages/admin/LeadsPage';
import SettingsEditor from './pages/admin/SettingsEditor';
import './index.css';
import '@questlabs/react-sdk/dist/style.css';

// Protects admin routes: requires Supabase Auth + role === 'admin'
const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    isAdmin().then(setAllowed).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }
  return allowed ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/social" element={<Social />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/hero" element={<ProtectedRoute><HeroEditor /></ProtectedRoute>} />
          <Route path="/admin/about" element={<ProtectedRoute><AboutEditor /></ProtectedRoute>} />
          <Route path="/admin/events" element={<ProtectedRoute><EventsEditor /></ProtectedRoute>} />
          <Route path="/admin/resources" element={<ProtectedRoute><ResourcesEditor /></ProtectedRoute>} />
          <Route path="/admin/leads" element={<ProtectedRoute><LeadsPage /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><SettingsEditor /></ProtectedRoute>} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;